import React from 'react';
import styles from './BadgePill.module.scss';

type BadgePillProps = {
  label: string;
  isEllipsis?: boolean;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

const BadgePill: React.FC<BadgePillProps> = ({
  label,
  isEllipsis = false,
  className = '',
  onClick,
  children
}) => {
  return (
    <div 
      className={`${styles.badgePill} ${isEllipsis ? styles.ellipsis : ''} ${className}`}
      onClick={onClick}
    >
      {label}
      {children}
    </div>
  );
};

export default BadgePill;
